import React from "react";
import { useNavigate } from "react-router-dom";
import Container from "@/components/foundation/Container";
import Button from "@/components/foundation/Button";
import FadeIn from "@/components/foundation/FadeIn";
import GlowOrb from "@/components/foundation/GlowOrb";
import GridPattern from "@/components/foundation/GridPattern";
import { ArrowRight } from "lucide-react";

export const FinalCtaSection = ({ onQualifyClick }) => {
  const navigate = useNavigate();
  return (
    <section
      className="relative overflow-hidden py-32 sm:py-40"
      data-testid="final-cta-section"
    >
      <GridPattern variant="dots" size={30} opacity={0.5} />
      <GlowOrb
        color="emerald"
        size={860}
        intensity={0.28}
        className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      />

      <Container className="relative z-10">
        <div className="mx-auto flex max-w-4xl flex-col items-center gap-8 text-center">
          <FadeIn>
            <h2 className="font-display text-5xl font-semibold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl text-balance">
              Your business already tells a story.
              <br />
              <span className="bg-gradient-to-r from-brand-emerald to-[#7CFFC0] bg-clip-text text-transparent">
                ZenMe helps translate it.
              </span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.1}>
            <p className="max-w-2xl text-base text-text-secondary sm:text-lg">
              Join the next generation of business capital infrastructure.
            </p>
          </FadeIn>

          <FadeIn delay={0.18}>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <Button
                variant="primary"
                size="lg"
                onClick={onQualifyClick}
                rightIcon={<ArrowRight className="h-4 w-4" />}
                data-testid="final-cta-qualify-btn"
              >
                See What You Qualify For
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={() => navigate("/partners")}
                data-testid="final-cta-partners-btn"
              >
                Become a Funding Partner
              </Button>
            </div>
          </FadeIn>
        </div>
      </Container>
    </section>
  );
};

export default FinalCtaSection;
